export default class NullStorageImpl implements IStorageImplementation {
	clear(): void {}
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setItem(key: string, value: Record<string, any>): void {}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	getItem(key: string): any {
		return null;
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	removeItem(key: string): void {}
}
